import {ResolveFn} from '@angular/router';
import {ApiService} from "@/app/api";
import {inject} from "@angular/core";
import {map} from "rxjs";
import {Protocol} from "@models/sportexam";

export const  protocolResolver: ResolveFn<Protocol> =  (route, state) => {
    const apiService = inject(ApiService)
    const id = route.paramMap.get('id');
    if(id==='create') return
    return apiService.Protocols.getProtocolById(+id).pipe(map(({data})=>data));
};
export const  protocolParentResolver: ResolveFn<Protocol> =  (route, state) => {
    const apiService = inject(ApiService)
    const id = route.parent.paramMap.get('id');
    if(id==='create') return
    return apiService.Protocols.getProtocolById(+id).pipe(map(({data})=>data));
};
